export interface QualityPhoto {
  name: string
  size: number
  type: string
  dataUrl: string
}

export interface QualityPhotosRecord {
  photos: QualityPhoto[]
  approved: boolean
  approvedAt: string | null
  rejectedAt: string | null
}

const EMPTY: QualityPhotosRecord = {
  photos: [],
  approved: false,
  approvedAt: null,
  rejectedAt: null
}

const storageKey = (jobId: string) => `marketplace-quality-photos-${jobId}`

export function loadQualityPhotos (jobId: string): QualityPhotosRecord {
  if (typeof window === 'undefined') return { ...EMPTY }
  const raw = window.localStorage.getItem(storageKey(jobId))
  if (!raw) return { ...EMPTY }
  try {
    const parsed = JSON.parse(raw) as unknown
    if (Array.isArray(parsed)) {
      // Legacy: array of metadata only.
      const photos = parsed
        .filter((item): item is { name: string; size: number; type: string } =>
          typeof item === 'object' && item !== null && typeof (item as { name?: unknown }).name === 'string')
        .map(item => ({ name: item.name, size: item.size, type: item.type, dataUrl: '' }))
      return { photos, approved: false, approvedAt: null, rejectedAt: null }
    }
    if (parsed && typeof parsed === 'object') {
      const record = parsed as Partial<QualityPhotosRecord>
      return {
        photos: Array.isArray(record.photos) ? record.photos : [],
        approved: Boolean(record.approved),
        approvedAt: record.approvedAt ?? null,
        rejectedAt: record.rejectedAt ?? null
      }
    }
  } catch {
    // fall through
  }
  return { ...EMPTY }
}

export function saveQualityPhotos (jobId: string, record: QualityPhotosRecord): void {
  if (typeof window === 'undefined') return
  window.localStorage.setItem(storageKey(jobId), JSON.stringify(record))
}

export function readFileAsDataUrl (file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(typeof reader.result === 'string' ? reader.result : '')
    reader.onerror = () => reject(reader.error ?? new Error('Unable to read file'))
    reader.readAsDataURL(file)
  })
}
